import React from 'react';
import classNames from 'classnames';

interface Props {
  children: React.ReactNode;
  heading?: string;
  className?: string;
}

const AttendeePanel: React.FC<Props> = (props) => {
  const { children, heading, className } = props;

  return (
    <div
      className={classNames(
        'flex flex-col px-6 py-8 gap-4 bg-grey-100 rounded-md',
        className,
      )}
    >
      {heading && <h5>{heading}</h5>}

      {children}
    </div>
  );
};

export default AttendeePanel;
